import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'ttag'
import styled from 'styled-components/macro'
import { show } from 'redux-modal'
import { updateSelectedFilters } from 'store/actions/filters'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'
import CustomCheckbox from 'components/ui/CustomCheckbox'
import FilterTitle from 'components/ui/FilterTitle'

const StyledMultiSelectFields = styled.div`
  div {
    margin: 10px 0;
    display: flex;
    align-items: center;
    label {
      margin-left: 10px;
      font-size: 12px;
    }
  }
`
function MultiSelectFields({
  type,
  filterData,
  values,
  title,
  showFilter,
  customTop,
  position,
  hide,
  selection,
  radioChecked,
  change,
  identifier
}) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const filterObject = filters.selectedFilters[currentSearchable][type]
  return (
    <PureMultiSelectFields
      type={type}
      values={values}
      filterData={filterData}
      title={title}
      showFilter={showFilter}
      customTop={customTop}
      filterObject={filterObject}
      position={position}
      hide={hide} //lets you hide parts of yourcomponent
      selection={selection}
      radioChecked={radioChecked}
      change={change}
      identifier={identifier}
    />
  )
}
const PureMultiSelectFields = React.memo(function Pure({
  type,
  filterData,
  values,
  title,
  showFilter,
  customTop,
  filterObject,
  position,
  radioChecked,
  change,
  identifier
}) {
  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(false)
  const selectedValues = filterObject[values[0]].map(option => ({
    label: option,
    id: option
  }))

  const options = filterData.map(option => {
    const parentOption = {
      label: option[1],
      value: option[0],
      expanded: true
    }
    const selectedOption = selectedValues.filter(s => s.id === option[0])
    if (selectedOption.length > 0) {
      parentOption.checked = true
    }
    return parentOption
  })
  const defaultSelection = selectedValues.length === options.length

  if (selectedValues.length === 0 && !initialized) {
    const filterValue = options.map(node => node.value)
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))
    setInitialized(true)
  }

  useEffect(() => {
    if (showFilter && position != 'reduced') {
      if (filterObject.list.length === 0) {
        dispatch(
          show('alertModal', {
            title,
            message: t`Note that this filter has only effect on the text search and the text search seems to be empty.`
          })
        )
      }
    }
  }, [dispatch, filterObject.list.length, showFilter, title])

  const onChange = event => {
    let currentData = []
    if (selectedValues.some(s => s.id === event.target.value)) {
      if ('partner__name__unaccent__exact' === event.target.value) {
        currentData = selectedValues
          .filter(
            d =>
              d.id !== 'partner__name_translated__unaccent__contains' &&
              d.id !== 'partner__name__unaccent__exact'
          )
          .map(d => d.id)
      } else {
        currentData = selectedValues.filter(d => d.id !== event.target.value).map(d => d.id)
      }
    } else {
      currentData = [...selectedValues.map(d => d.id)]
      currentData.push(event.target.value)
      if ('partner__name__unaccent__exact' === event.target.value) {
        currentData.push('partner__name_translated__unaccent__contains')
      }
    }

    const data = {
      filterType: type,
      filterId: values[0],
      filterValue: currentData
    }

    dispatch(updateSelectedFilters(data))
  }

  const accordionChanged = event => {
    change(identifier, event)
  }

  const selectAll = () => {
    if (options.length === selectedValues.length) {
      const data = {
        filterType: type,
        filterId: values[0],
        filterValue: []
      }
      dispatch(updateSelectedFilters(data))
      return
    }

    const currentData = options.map(o => o.value)
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue: currentData
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      if (filterValue === 'partner__name__unaccent__exact') {
        resultingValue = filterObject[filterId].filter(
          s =>
            (s.id !== filterValue.id || s !== filterValue) &&
            s !== 'partner__name_translated__unaccent__contains'
        )
      } else {
        resultingValue = filterObject[filterId].filter(
          s => s.id !== filterValue.id || s !== filterValue
        )
      }
    }
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterLabel(filterValue) {
    const resultingFilter = filterData.filter(filter => filter[0] === filterValue)
    return resultingFilter[0][1]
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (defaultSelection) {
        return '' /*
          <SelectedFilterContainer key={value.id ? value.id : value} className="selected-filters">
            <SelectedFilter>
              <FilterText title={type == 'search' ? t`All fields` : t`All alpha-numeric fields`}>
                <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>
                {type == 'search' ? t`All fields` : t`All alpha-numeric fields`}
                </Dotdotdot>
              </FilterText>
            </SelectedFilter>
          </SelectedFilterContainer>*/
      } else if (filterObject[value]) {
        const filterValue = filterObject[value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v.id ? v.id : v}>
              {v !== 'partner__name_translated__unaccent__contains' && (
                <SelectedFilter>
                  <FilterText title={handleFilterLabel(v)}>
                    <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{handleFilterLabel(v)}</Dotdotdot>
                  </FilterText>
                  <RemoveIcon
                    className="far fa-times"
                    onClick={() => handleFilterRemove(value, v, true)}
                  />
                </SelectedFilter>
              )}
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }
  /*
  function noneSelected() {
    return(
      <SelectedFilterContainer key="1" className="selected-filters">
        <SelectedFilter>
          <FilterText title={type == 'search' ? t`All` : t`All alpha-numeric fields`}>
            <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>
            {type == 'search' ? t`None` : t`No filter selected`}
            </Dotdotdot>
          </FilterText>
        </SelectedFilter>
      </SelectedFilterContainer>
    )
  } */
  return (
    <>
      <div className="bottoncione">
        <input
          type="checkbox"
          className="accordion-checker"
          checked={radioChecked === identifier}
          id={`accordion-${title.replace(/ /g, '_').toLowerCase()}`}
          onChange={event => accordionChanged(event)}
          hidden
        />
        <label htmlFor={`accordion-${title.replace(/ /g, '_').toLowerCase()}`}>{title}</label>
        <SearchFilter
          customTop={customTop}
          className={
            'filter-container side-container ' + (position == 'reduced' ? 'reduced-fl' : '')
          }
        >
          <div className="sticky-container multi-select-fields">
            {title ? <FilterTitle>{title}</FilterTitle> : null}
            <StyledMultiSelectFields>
              <CustomCheckbox isChecked={selectedValues.length === options.length}>
                <input
                  type="checkbox"
                  checked={selectedValues.length === options.length}
                  onChange={selectAll}
                  id="id-select-all"
                />
                <label htmlFor="id-select-all">
                  {selectedValues.length === options.length ? t`Unselect all` : t`Select all`}
                </label>
              </CustomCheckbox>
              {options.map(
                data =>
                  data.value !== 'partner__name_translated__unaccent__contains' && (
                    <CustomCheckbox
                      key={data.value}
                      isChecked={selectedValues.some(s => s.id === data.value)}
                    >
                      <input
                        type="checkbox"
                        checked={selectedValues.some(s => s.id === data.value)}
                        value={data.value}
                        onChange={onChange}
                        id={`id-${data.value}-checkbox`}
                      />
                      <label htmlFor={`id-${data.value}-checkbox`}>{data.label}</label>
                    </CustomCheckbox>
                  )
              )}
            </StyledMultiSelectFields>
          </div>
        </SearchFilter>
      </div>
      <div className="container-selected-filters">
        <div className="selected-fl">{renderSelectedValues()}</div>
      </div>
    </>
  )
})

MultiSelectFields.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  position: PropTypes.string,
  values: PropTypes.array,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  hide: PropTypes.bool,
  selection: PropTypes.bool,
  changedState: PropTypes.func,
  inputData: PropTypes.object,
  radioChecked: PropTypes.string,
  change: PropTypes.func,
  identifier: PropTypes.string
}

PureMultiSelectFields.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  position: PropTypes.string,
  values: PropTypes.array,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  filterObject: PropTypes.object,
  hide: PropTypes.bool,
  selection: PropTypes.bool,
  changedState: PropTypes.func,
  inputData: PropTypes.object,
  radioChecked: PropTypes.string,
  change: PropTypes.func,
  identifier: PropTypes.string
}

export default MultiSelectFields
